import React, { useState } from "react";
import toast from "react-hot-toast";
import axiosInstant from "../../../api";
import ExportFieldsModal, { ExportField } from "../../../components/ExportFieldsModal/ExportFieldsModal";

const fieldsList: ExportField[] = [
    { label: "Project ID", value: "projectId" },
    { label: "Title", value: "title" },
    { label: "Brand Name(s)", value: "brandNames" },
    { label: "Product Name(s)", value: "productNames" },
    { label: "Status", value: "status" },
    { label: "Expert Name(s)", value: "expertNames" },
    { label: "Film Date", value: "filmDate" },
    { label: "Content Type", value: "contentTypeName" },
    { label: "TDC Shipping Status", value: "tdc_shipping_status" },
    { label: "Expert Shipping Status", value: "expert_shipping_status" },
    { label: "Address", value: "fullAddress" },
    { label: "Association ID", value: "associationId" },
    { label: "Can Ship Two", value: "canShipTwo" },
    { label: "Client Feedback Tracker", value: "client_feedback_tracker" },
    { label: "Content Channel", value: "contentChannelName" },
    { label: "Created Date", value: "createdDate" },
    { label: "Description", value: "description" },
    { label: "Expert Count", value: "expertCount" },
    { label: "Expert Score(s)", value: "expertScores" },
    { label: "Expert Selected Date", value: "expertSelectedDate" },
    { label: "Online Purchase", value: "onlinePurchase" },
    { label: "Order Name", value: "orderName" },
    { label: "Over 100 lbs", value: "over100Lbs" },
    { label: "Point of Contact (Brand)", value: "brand_point_of_contact" },
    { label: "Point of Contact (TDC)", value: "point_of_contact" },
    { label: "Product Received by Expert", value: "productReceivedByExpert" },
    { label: "Product Received by TDC", value: "productReceivedByTdc" },
    { label: "RMN Brand", value: "rmnBrand" },
    { label: "Slack Channel", value: "slack_channel" },
    { label: "SOW Name", value: "sowName" },
    { label: "Tracking", value: "tracking" },
    { label: "Video Count", value: "videoCount" },
];

interface Props {
    showDialog: boolean;
    setShowDialog: (show: boolean) => void;
    filters?: Record<string, any>;
}

export default function DownloadProjectCsv({ showDialog, setShowDialog, filters }: Props) {
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShowDialog(false);

    const downloadProjects = (selectedFields: ExportField[]) => {
        setLoading(true);

        const params: Record<string, any> = {
            ...filters,
            selectedFields: JSON.stringify(selectedFields),
        };

        axiosInstant
            .get("/brand-projects/csv", { params })
            .then((response) => {
                handleClose();
                const encodedUri = encodeURI(response.data);
                window.open(encodedUri);
            })
            .catch((error) => {
                console.error(error.response);
                toast.error("Unable to download. Kindly try again.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <ExportFieldsModal
            open={showDialog}
            onClose={handleClose}
            fields={fieldsList}
            loading={loading}
            onExport={downloadProjects}
        />
    );
}
